/**
 *
 * Asynchronously loads the component for Booking
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
